<aside class="new-features" [@slideOut]="isHidden ? 'hidden' : 'visible'">
  <header class="new-features__header">
    <b [innerHtml]="not?.notification?.messages?.webMessage?.title"></b>
    <i class="material-icons ico-close" aria-label="fechar" (click)="closeNotification()">close</i>
  </header>
  <main [innerHtml]="not?.notification?.messages?.webMessage?.message"></main>
</aside>
